export const RESET_PASSWORD_HEADER = "reset-password-header";
export const RESET_PASSWORD_DESCRIPTION = "reset-password-description";
export const RESET_PASSWORD_FORM = "reset-password-form";
export const RESET_PASSWORD_BACK_BUTTON = "reset-password-back-button";
export const RESET_PASSWORD_SUBMIT_BUTTON = "reset-password-submit-button";
export const RESET_PASSWORD_CANCEL_BUTTON = "reset-password-cancel-button";
export const RESET_PASSWORD_BUTTON = "reset-password-button";
export const NEW_PASSWORD = "newPassword";
export const PASSWORD_UPDATED = "PASSWORD_UPDATED";
export const NEW_PASSWORD_LABEL = "new-password-label";
export const CURRENT_PASSWORD = "currentPassword";
export const INVALID_CURRENT_PASSWORD_TYPE = "invalidCurrentPassword";
export const INVALID_CURRENT_PASSWORD_ERROR_MESSAGE =
  "current-password-required-error-message";
export const PASSWORD_UPDATED_SUCCESSFULLY = "PASSWORD_UPDATED_SUCCESSFULLY";
export const INVALID_CURRENT_PASSWORD = "INVALID_CURRENT_PASSWORD";
